// Lot 9 : fonctions pures de la brique Courbe (testables sans JSX : la config vitest ne transforme pas le JSX).

/**
 * Échelle verticale d'une série : {min, max} des valeurs non nulles (et de `extra`, ex. la cible), élargie de 10 % de
 * l'étendue de chaque côté. Étendue nulle : marge de 10 % de la valeur (ou 1 si la valeur est 0). `null` sans valeur.
 */
export function echelle(points, extra = []) {
    const valeurs = [...points.map((p) => p.y), ...extra].filter((v) => typeof v === 'number' && Number.isFinite(v));
    if (valeurs.length === 0) return null;
    const lo = Math.min(...valeurs);
    const hi = Math.max(...valeurs);
    const marge = hi > lo ? (hi - lo) * 0.1 : (lo !== 0 ? Math.abs(lo) * 0.1 : 1);
    return {min: lo - marge, max: hi + marge};
}

/** Tronçons de points consécutifs non nuls : [[{i, y}, …], …] (un `null` coupe la ligne). */
export function troncons(points) {
    const res = [];
    let courant = null;
    points.forEach((p, i) => {
        if (typeof p.y === 'number' && Number.isFinite(p.y)) {
            if (!courant) res.push((courant = []));
            courant.push({i, y: p.y});
        } else courant = null;
    });
    return res;
}
